module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9N2MY"))).then(() => parcelRequire('1iHdE'));